export function dispatchCustomEvent(element: HTMLElement, eventName: string, detail?: unknown) {
    const event = new CustomEvent(eventName, {
        bubbles: true,
        composed: true,
        detail,
    })
    element.dispatchEvent(event)
}

export function dispatchErrorEvent(element: HTMLElement, eventName: string, error: Error) {
    const event = new ErrorEvent(eventName, {
        bubbles: true,
        composed: true,
        error,
        message: error.message,
    })
    element.dispatchEvent(event)
}
